<template>
  <v-card outlined class="scenario-card mb-3 state-affluence">
    <v-row class="px-3 py-2" align="center">
      <v-col cols="10" class="text-truncate">
        <strong class="text size-xsmall font-alt" align="start">
          {{ scenario.name }}
        </strong>
      </v-col>
      <v-spacer />
      <!-- <v-col cols="auto" align="end">
        <v-btn
          class="dot-button"
          fab
          x-small
          depressed
          icon
          @click="triggerUpdateCard()"
        >
          <v-icon class="">edit</v-icon>
        </v-btn>
      </v-col> -->
    </v-row>

    <v-divider></v-divider>

    <v-row class="px-3 pb-2" align="center">
      <v-col cols="12">
        Date d'envoi : {{ scenario.start_datetime }}
      </v-col>
      <!-- <v-col cols="12">
        Fin : {{ scenario.end_datetime }}
      </v-col> -->
    </v-row>

    <v-row class="ma-0 pa-0">
      <v-col cols="6" align="start">
        <v-switch
          v-model="scenario.is_active"
          @change="(v) => updateScenarioStatus(v)"
          label="Actif"
        >
        </v-switch>
      </v-col>
      <v-col cols="6" align="end">
        <div class="send-all-btn">
          <button @click="$emit('sendNow')">
            Envoyer maintenant
          </button>
        </div>
      </v-col>
    </v-row>
    <v-row class="ma-0 pa-0 bottom-bg-card">
      <v-col>
        <v-tooltip v-for="segment in scenario.segments" :key="`scenario-${scenario.id}-segment-${segment.id}`" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div
              v-bind="attrs"
              v-on="on"
              class="segment-marker"
              :style="{ 'background-color': segment.color }"
            />
          </template>
          <span>{{ segment.label }}</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>

export default {
  props: {
    scenario: {
      type: Object,
      required: true
    },
  },
  methods: {
    triggerUpdateCard() {
      this.$emit('trigger-update-card');
    },
    updateScenarioStatus(value) {
      const action = !!value ? 'enableScenario' : 'disableScenario';
      this.$store.dispatch(`scenarios/${action}`, {
        scenario_id: this.scenario.id,
      });
    },
  },
};
</script>

<style lang="scss">
.send-all-btn {
  button {
    padding: 8px;
    background: white;
    position: relative;
    border-radius: 5px;
    float: right;
    margin: 8px;
    box-shadow: 0 0 3px #b3a4a487;
    transition: all 0.3s;
    &:hover {
      background: #f9f6f6;
    }
    &:active {
      background: #e5e5ee;
    }
  }
}
.scenario-card {
  border-radius: 12px !important;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.05) !important;

  &.state-disabled {
    background-color: lightgrey !important;
  }

  &.state-affluence {
    border: 5px solid $color-primary !important;
    background-color: transparent !important;
  }

  &.state-consommation {
    border: 5px solid #ff6e6e !important;
    background-color: hsl(0, 90%, 80%) !important;
  }

  .bottom-bg-card {
    
  }

  .segment-marker {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    margin-right: 6px;
    max-width: 23px;
  }

  .v-progress-linear__determinate {
    border-radius: 3px !important;
    background-image: linear-gradient(
      0.25turn,
      #9062f4 0%,
      #574ace 75%
    ) !important;
  }

  .switch-container-adjust {
    max-width: 45px !important;
    justify-content: end;
  }

  .dot-button {
    background-color: transparent !important;
  }

  .v-progress-linear__buffer {
    border-radius: 3px !important;
  }

  .switch-track {
    .v-input--switch__track {
      color: #6f52ed !important;
    }
  }

  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-bottom: 6px;
  }
}
</style>
